import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLaw: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="law, legal, terms, imprint, balance"><path d="M12 2.75V20.25M12 20.25H6.75M12 20.25H17.25M2.75 5.75H8L10 4.75H14L16 5.75H21.25M2.5 15.25C4.57693 16.4267 6.42307 16.4267 8.5 15.25L5.57895 6H5.42105L2.5 15.25ZM15.5 15.25C17.5769 16.4267 19.4231 16.4267 21.5 15.25L18.5789 6H18.4211L15.5 15.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconLaw;
